export default class UserService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getAllUsers(args) {
    return this.axiosIns.get(this.serviceConfig.users, { params: args });
  }

  getUser(id) {
    return this.axiosIns.get(`${this.serviceConfig.users}/${id}`);
  }

  editCustomerUser(id, args) {
    return this.axiosIns.put(`${this.serviceConfig.users}/${id}`, args);
  }

  updatePersonalData(args) {
    return this.axiosIns.post(`${this.serviceConfig.users}/my-info`, args);
  }

  deleteCustomerUser(id) {
    return this.axiosIns.delete(`${this.serviceConfig.users}/${id}`);
  }
}
